<template>
  <div class="flex h-full">
    <el-card class="h-full flex flex-col flex-shrink-0" :class="isOpen ? 'w-300px' : 'hidden'">
      <div class="mb-10px flex items-center text-14px">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-[#303133] text-18px"
          >场景树</span
        >
        <el-dropdown>
          <span>
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mb-20px">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="treeKeyword"
          class="mr-10px flex-1"
          clearable
          @keyup.enter.native="getTreeData"
        ></el-input>
        <el-button
          type="primary"
          class="!h-36px"
          size="mini"
          @click="getTreeData"
          :disabled="!$hasAccess('check')"
          >搜索</el-button
        >
        <el-button
          :disabled="!$hasAccess('create')"
          type="primary"
          size="mini"
          class="!h-36px"
          @click="handleTreeData('create')"
          >新增</el-button
        >
      </div>
      <div class="flex-auto scene-tree h-[calc(100%-74px)] overflow-y-auto">
        <el-tree
          v-if="treeStandBy"
          v-loading="treeLoading"
          node-key="id"
          ref="tree"
          highlight-current
          :data="treeData"
          :expand-on-click-node="false"
          :props="defaultTreeProps"
          :current-node-key="currentSelectKey"
          :default-expanded-keys="defaultExpandIds"
          :default-expand-all="defaultExpandAll"
          @node-click="handleDocNodeClick"
        >
          <div slot-scope="{ node, data }" class="w-[calc(100%-24px)]">
            <div class="flex items-center text-14px">
              <p :title="node.label" class="flex-1 mr-15px truncate pt-1px">{{ node.label }}</p>
              <div class="mr-5px">
                <el-dropdown>
                  <span>
                    <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :disabled="!$hasAccess('create')"
                      @click.native="handleTreeData('create', data)"
                      >新增</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="data.id"
                      :disabled="!$hasAccess('update')"
                      @click.native="handleTreeData('edit', data)"
                      >编辑</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="data.id"
                      :disabled="!$hasAccess('delete')"
                      @click.native="removeTreeData(data)"
                      >删除</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </el-card>
    <!-- <div class="w-10px relative" :class="isOpen ? 'left-10px' : 'left-0'">
      <i
        class="absolute w-26px h-26px bg-blue-500 text-white top-40px -left-10px flex items-center justify-center cursor-pointer rounded-4px"
        :class="isOpen ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
        @click="isOpen = !isOpen"
      ></i>
    </div>-->
    <div class="w-10px relative left-10px"></div>
    <el-card class="h-full flex-1" :class="isOpen ? '' : '-ml-10px'">
      <div class="my-20px">
        <el-input
          v-model="keyword"
          class="mr-10px w-200px"
          placeholder="请输入关键字"
          clearable
        ></el-input>
        <!-- button按钮部分 -->
        <el-button type="primary" @click="searchSceneList" :disabled="!$hasAccess('check')"
          >搜索</el-button
        >
        <el-button type="primary" @click="operateScene('create')" :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button type="danger" @click="batchDelete" :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
      </div>
      <div class="h-[calc(100%-143px)] flex flex-wrap overflow-auto content-start">
        <el-card
          shadow="always"
          v-for="item in sceneList"
          :key="item.id"
          class="scene-card 2xl:w-[calc(20%-20px)] xl:w-[calc(25%-20px)] md:w-[calc(33%-20px)] h-240px mr-20px mb-20px text-14px"
        >
          <div
            class="w-full h-160px bg-no-repeat bg-cover bg-center"
            :style="item.picUrl && `background-image: url(${item.picUrl})`"
          ></div>
          <div class="bg-[#c4c4c4] h-60px text-white px-5px py-10px">
            <div class="flex justify-between mb-10px">
              <div class="flex w-[calc(100%-100px)]">
                <el-checkbox
                  v-model="item.isChecked"
                  @change="(val) => handleCheckedChange(val, item.id)"
                  class="!mr-5px"
                ></el-checkbox>
                <div :title="item.name" class="max-w-100px truncate pt-1px">{{ item.name }}</div>
              </div>
              <div class="cursor-pointer w-100px">
                <span @click="updateScene(item.id)">编辑场景</span> |
                <el-dropdown>
                  <span class="text-white">更多</span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-if="$hasAccess('update')"
                      @click.native="updateSceneModel(item)"
                      >更新场景素材</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="$hasAccess('update')"
                      @click.native="operateScene('update', item)"
                      >编辑信息</el-dropdown-item
                    >
                    <el-dropdown-item v-if="$hasAccess('update')" @click.native="cloneScene(item)"
                      >克隆场景</el-dropdown-item
                    >
                    <el-dropdown-item v-if="$hasAccess('delete')" @click.native="deleteScene(item)"
                      >删除场景</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div :title="item.creationTime" class="w-full truncate">
              建立时间：{{ item.creationTime }}
            </div>
          </div>
        </el-card>
      </div>
      <div class="mt-20px flex justify-end">
        <el-pagination
          background
          @size-change="searchSceneList"
          @current-change="getSceneList"
          :current-page.sync="page.pageNo"
          :page-sizes="pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="(treeOperateType === 'create' ? '新增' : '编辑') + '目录'"
      :visible.sync="treeDialog"
      v-dialogDrag
      @close="closeTreeForm"
      class="mini-dialog"
    >
      <el-form :model="treeForm" label-width="160px" :rules="treeRules" ref="treeFormRef">
        <el-form-item label="目录名称" prop="name">
          <el-input
            v-model="treeForm.name"
            :type="treeOperateType === 'create' ? 'textarea' : 'text'"
            :nums="3"
            :autosize="{ minRows: 3, maxRows: 10 }"
            size="small"
            clearable
            :placeholder="
              treeOperateType === 'create' ? '可通过换行添加多条目录' : '请输入目录名称'
            "
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveTreeForm" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="closeTreeForm">取消</el-button>
      </div>
    </el-dialog>
    <AddScene
      v-if="addVisible"
      :visible.sync="addVisible"
      :operateType="operateType"
      :operateProps="operateProps"
      :treeData="pathTreeData"
      :sceneFlatData="sceneFlatData"
      :folderId="currentSelectKey"
      @refresh="searchSceneList"
    ></AddScene>
    <CloneScene
      v-if="cloneVisible"
      :visible.sync="cloneVisible"
      :operateProps="operateProps"
      :treeData="pathTreeData"
      :sceneFlatData="sceneFlatData"
      @refresh="searchSceneList"
    ></CloneScene>
  </div>
</template>

<script>
import {
  difference,
  isNil,
  isEmpty,
  map,
  filter,
  includes,
  split,
  forEach,
  findIndex,
  eq,
  get,
  nth,
} from 'lodash'
import { ModelMenuApi, ModelSceneApi } from '@wiz-api/scene-management'
import { FileApi } from '@wiz-api/file-management'
import { ModelApi, AnimationApi } from '@wiz-api/material-management'
import dayjs from 'dayjs'

const modelMenuApi = new ModelMenuApi()
const modelSceneApi = new ModelSceneApi()
const modelApi = new ModelApi()
const animationApi = new AnimationApi()
const fileApi = new FileApi()

const AddScene = () => {
  return import('../components/AddScene')
}
const CloneScene = () => {
  return import('../components/CloneScene')
}
export default {
  components: {
    AddScene,
    CloneScene,
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (Array.isArray(routerBase)) {
        // 多个微服务场景取第一个基础微服务
        return `/${routerBase[0]}`
      }
      return routerBase ? `/${routerBase}` : ''
    },
  },
  data() {
    return {
      isOpen: true,
      treeKeyword: '',
      treeDialog: false,
      // 场景树展示的
      treeData: [],
      // 下拉框选择的路径（剔除根目录）
      pathTreeData: [],
      sceneFlatData: [],
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      treeStandBy: true,
      defaultExpandIds: [],
      defaultExpandAll: false,
      treeForm: {
        name: '',
      },
      treeRules: {
        name: { required: true, message: '请输入目录名称', trigger: 'blur' },
      },
      saveLoading: false,
      keyword: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      sceneList: [],
      addVisible: false,
      operateType: 'create',
      operateProps: null,
      cloneVisible: false,
      currentTreeData: null,
      treeOperateType: '',
      selectSceneIds: [],
      currentSelectKey: '',
      selectParentId: '',
      sceneFileList: [],
    }
  },
  async created() {
    await this.getTreeData()
    if (this.treeData.length) {
      this.handleDocNodeClick(this.treeData[0])
    }
  },
  methods: {
    // 获取素材详情
    async getModelMaterial(id) {
      const [err, res] = await modelApi.get(id)
      if (!err && res) {
        return res
      }
      return {}
    },
    async getAnimationMaterial(id) {
      const [err, res] = await animationApi.get(id)
      if (!err && res) {
        return res
      }
      return {}
    },
    // 通过指定节点去查下面的子节点 nodeType 指定节点的类型，obj 需要筛选的对象数据源，arr 接收筛选后的数据集合
    async traverseSceneData(obj) {
      const enumObjectTypes = [
        'modelFile', // 模型类型
        'dynamicEffects',
      ]
      const currentNodeType = obj?.code?.type
      if (enumObjectTypes.includes(currentNodeType)) {
        let materialInfo = null
        if (currentNodeType === 'modelFile') {
          materialInfo = await this.getModelMaterial(obj?.code?.modelId)
        } else {
          materialInfo = await this.getAnimationMaterial(obj?.code?.modelId)
        }
        const modelFile = _.find(materialInfo?.medias || [], ['mediaType', 1])
        const textureFile = _.find(materialInfo?.medias || [], ['mediaType', 2])
        if (modelFile) {
          obj.code.filePath = obj.code.filePath.replaceAll(
            obj.code.modelFileId,
            modelFile.fileInfoId
          )
          obj.code.modelFileId = modelFile.fileInfoId
        }
        obj.code.materialFileId = textureFile ? textureFile.fileInfoId : ''
      }
      // 递归子，继续创建
      if (obj.children && obj.children.length) {
        for (let i = 0; i < obj.children.length; ++i) {
          // eslint-disable-next-line no-await-in-loop
          await this.traverseSceneData(obj.children[i])
        }
      }
    },
    // 更新场景中的模型
    async updateSceneModel(data) {
      const [err, res] = await modelSceneApi.getModelSecenRelatedJson({ id: data.id })
      console.log(res)
      if (!err && res) {
        const sceneData = JSON.parse(res)
        console.log(sceneData)
        await this.traverseSceneData(sceneData)
        const [sceneErr, sceneRes] = await modelSceneApi.saveModelSecenRelatedJson({
          body: {
            id: data.id,
            jsonContent: JSON.stringify(sceneData),
          },
        })
        if (!sceneErr) {
          this.$message.success('更新成功')
        }
      }
    },
    // 获取树的数据
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await modelMenuApi.menuPageQueryList({
        keyWord: this.treeKeyword,
        isQueryAsTree: true,
      })
      if (!err && !isNil(res)) {
        this.pathTreeData = res.items
        this.treeData = [
          {
            id: '',
            name: '根目录',
            children: res.items,
          },
        ]
        this.treeStandBy = false
        if (isEmpty(this.defaultExpandIds)) {
          this.defaultExpandIds = [this.treeData[0].id]
        } else if (!isEmpty(this.selectParentId)) {
          this.defaultExpandIds.push(this.selectParentId)
        }
        this.$nextTick(() => {
          this.treeStandBy = true
        })
      }
      this.treeLoading = false
    },
    // 获取扁平的目录，传递给子组件使用
    async getFlatData() {
      const [err, res] = await modelMenuApi.menuPageQueryList({
        isQueryAsTree: false,
        isIgnoreParentIdWhenQuery: true,
      })
      if (!err && !isNil(res)) {
        this.sceneFlatData = res.items
      }
    },
    // 目录树的增删改操作
    async handleTreeData(type, data) {
      this.currentTreeData = data
      if (type !== 'create') {
        this.treeForm.name = data.name
      }
      this.treeOperateType = type
      this.treeDialog = true
    },
    // 收起或展开
    operateTree(bool) {
      if (!bool) {
        this.defaultExpandIds = []
      }
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 点击节点
    handleDocNodeClick(data) {
      this.currentSelectKey = data.id
      this.selectParentId = data.parentId
      this.searchSceneList()
    },
    // 删除树节点数据
    async removeTreeData(data) {
      // 判断目录下是否有场景
      const [err, res] = await modelSceneApi.getList({
        name: '',
        folderId: data.id,
      })
      let msg = '此操作将永久删除该数据, 是否继续?'
      if (!err && !isEmpty(res) && res.items.length) {
        msg = '该目录下有场景数据，是否确定删除?'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await modelMenuApi.callDelete(data.id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            if (this.currentSelectKey === data.id) {
              // 如果删除的是当前显示场景列表的树节点，则场景列表置为空
              this.sceneList = []
            }
            this.defaultExpandIds = [data.parentId]
            await this.getTreeData()
          }
        })
        .catch(() => {})
    },
    // 保存目录操作
    saveTreeForm() {
      this.$refs.treeFormRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          // 新增
          if (this.treeOperateType === 'create') {
            const [err, res] = await modelMenuApi.addMutlFolders({
              body: {
                names: filter(split(this.treeForm.name, '\n'), (item) => {
                  return item !== ''
                }),
                parentId: isEmpty(this.currentTreeData?.id) ? null : this.currentTreeData.id,
              },
            })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增目录成功',
              })
              if (!isEmpty(this.currentTreeData)) {
                this.defaultExpandIds = [this.currentTreeData.id]
              }
              await this.getTreeData()
              this.closeTreeForm()
            }
          } else {
            // 编辑
            const [err, res] = await modelMenuApi.update(this.currentTreeData.id, {
              body: {
                name: this.treeForm.name,
                parentId: this.currentTreeData.parentId,
                id: this.currentTreeData.id,
              },
            })
            if (!err && !isNil(res)) {
              this.$message.success({
                showClose: true,
                message: '编辑目录成功',
              })
              if (!isEmpty(this.currentTreeData)) {
                this.defaultExpandIds = [this.currentTreeData.parentId]
              }
              await this.getTreeData()
              this.closeTreeForm()
            }
          }
          this.saveLoading = false
        }
      })
    },
    // 关闭树节点操作弹框
    closeTreeForm() {
      this.treeDialog = false
      this.treeForm = this.$options.data().treeForm
      this.$refs.treeFormRef.resetFields()
    },
    // 获取场景列表
    async getSceneList() {
      this.selectSceneIds = []
      const [err, res] = await modelSceneApi.getList({
        name: this.keyword,
        folderId: this.currentSelectKey,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && !isNil(res)) {
        this.sceneList = map(res.items, (item) => {
          return {
            ...item,
            // 处理缩略图默认值
            shortCutPicFileId:
              item.shortCutPicFileId === '00000000-0000-0000-0000-000000000000'
                ? null
                : item.shortCutPicFileId,
            creationTime: dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss'),
            picUrl: '',
          }
        })
        this.page.total = res.totalCount
        forEach(this.sceneList, async (item, index) => {
          if (!isEmpty(item.shortCutPicFileId)) {
            const picUrl = await this.getPic(item.shortCutPicFileId)
            if (eq(get(nth(this.sceneList, index), 'id'), item.id)) {
              this.$set(this.sceneList, index, { ...item, picUrl })
            }
          }
        })
      }
    },
    // 获取图片
    async getPic(id) {
      const [err, res] = await fileApi.getFileContent(id)
      if (!err && !isNil(res)) {
        return `data:image/jpg;base64,${res.content}`
      }
    },
    // 搜索
    searchSceneList() {
      this.page.pageNo = 1
      this.getSceneList()
    },
    // 选中操作
    handleCheckedChange(value, id) {
      if (value) {
        this.selectSceneIds.push(id)
      } else {
        this.selectSceneIds.splice(
          findIndex(this.selectSceneIds, (item) => {
            return item === id
          }),
          1
        )
      }
    },
    // 编辑场景进入三维页面
    async updateScene(id) {
      console.log('进入三维编辑场景')
      const [err, res] = await modelSceneApi.checkModelSceneModifyState({ id })
      if (!err && !isNil(res)) {
        if (res.isModifyAble) {
          this.$router.push(
            `${this.basePath}/scene-configure/index?sceneId=${id}${
              this.basePath ? '&ShowClassicTop=false&ShowClassicLeft=false' : ''
            }`
          )
        } else {
          this.$message.warning({
            showClose: true,
            message: `当前场景正在被${res.lastModifyUserName}编辑`,
          })
        }
      }
    },
    // 操作场景
    async operateScene(type, value) {
      // 获取最新的扁平目录
      await this.getFlatData()
      this.operateType = type
      if (type === 'create') {
        this.operateProps = null
      } else {
        this.operateProps = value
      }
      this.addVisible = true
    },
    // 批量删除
    batchDelete() {
      if (!this.selectSceneIds.length) {
        return this.$message.warning({
          showClose: true,
          message: '请勾选场景',
        })
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await modelSceneApi.deleteMany({
            ids: this.selectSceneIds,
          })
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            await this.getSceneList()
          }
        })
        .catch(() => {})
    },
    // 克隆场景
    async cloneScene(value) {
      // 获取最新的扁平目录
      await this.getFlatData()
      this.operateProps = value
      this.cloneVisible = true
    },
    // 删除场景
    deleteScene(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await modelSceneApi.callDelete(data.id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            await this.getSceneList()
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}

.scene-tree {
  ::v-deep .el-tree-node__content {
    height: 35px;
  }
}

.scene-card {
  ::v-deep .el-card__body {
    padding: 10px;
  }
}
</style>
